import { type ComponentType, lazy } from 'react'

const STORAGE_PREFIX = 'chunk-retry:'

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const message = error.message
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Unable to preload CSS')
  )
}

export function lazyWithRetry<T extends ComponentType>(
  factory: () => Promise<{ default: T }>,
): React.LazyExoticComponent<T> {
  return lazy(() =>
    factory().catch((error: unknown) => {
      if (!isChunkLoadError(error)) throw error

      const key = `${STORAGE_PREFIX}${window.location.pathname}`
      const hasRetried = sessionStorage.getItem(key)

      if (hasRetried) {
        sessionStorage.removeItem(key)
        throw error
      }

      sessionStorage.setItem(key, '1')
      window.location.reload()

      // reload 後にPromiseが解決されることはないが、型を満たすため
      return new Promise<never>(() => {})
    }),
  )
}

export { isChunkLoadError }
